import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Redirect = ({ route }) => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(route);
  }, []);
  return <div>Redirecting...</div>;
};

export default Redirect;
